import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="my-4 flex items-center justify-center gap-1.5 text-center sm:gap-2" data-id="element-180" data-mp="34qi6ovkcuh1i">
      <div className="min-w-[52px] rounded bg-red-600 px-2 py-2 text-white sm:min-w-[60px] sm:px-3" data-id="element-181" data-mp="2zrnp1wy4iyiz">
        <span className="text-xl font-bold sm:text-2xl" data-id="element-182" data-mp="1c0yfe4mz3swf">
          {String(timeLeft.hours).padStart(2, '0')}
        </span>
        <div className="text-[9px] uppercase sm:text-[10px]" data-id="element-183" data-mp="1h01ktq6v814x">Horas</div>
      </div>
      <div className="py-1 text-xl font-bold text-red-600 sm:text-2xl" data-id="element-184" data-mp="122r3i07jk11a">:</div>
      <div className="min-w-[52px] rounded bg-red-600 px-2 py-2 text-white sm:min-w-[60px] sm:px-3" data-id="element-185" data-mp="124vbouch3m7d">
        <span className="text-xl font-bold sm:text-2xl" data-id="element-186" data-mp="1ur6e8ajn3x6t">
          {String(timeLeft.minutes).padStart(2, '0')}
        </span>
        <div className="text-[9px] uppercase sm:text-[10px]" data-id="element-187" data-mp="1zqsu6rqurrjb">Minutos</div>
      </div>
      <div className="py-1 text-xl font-bold text-red-600 sm:text-2xl" data-id="element-188" data-mp="1l1msmx4jlp89">:</div>
      <div className="min-w-[52px] rounded bg-red-600 px-2 py-2 text-white sm:min-w-[60px] sm:px-3" data-id="element-189" data-mp="1kzirgmy134bo">
        <span className="text-xl font-bold sm:text-2xl" data-id="element-190" data-mp="1py3ibvre4bng">
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
        <div className="text-[9px] uppercase sm:text-[10px]" data-id="element-191" data-mp="2ihahggsx1uxa">Segundos</div>
      </div>
    </div>;
}